import { useMemo } from "react";
import { useUnpublishedProjectsQuery } from "../../../common/hooks/projects/useUnpublishedProjectsQuery";

export const useUnpublishedPastProjectsOptions = () => {
  const { data: projects, isLoading } = useUnpublishedProjectsQuery();

  const data = useMemo(() => {
    return (
      projects?.map((project) => {
        return {
          ...project,
          title: project?.title,
          id: project?._id,
        };
      }) ?? []
    );
  }, [projects]);

  return { data, isLoading };
};
